import { render, staticRenderFns } from "./OrdenesSerTecPantalla.vue?vue&type=template&id=42e37afe&"
import script from "./OrdenesSerTecPantalla.vue?vue&type=script&lang=ts&"
export * from "./OrdenesSerTecPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42e37afe', component.options)
    } else {
      api.reload('42e37afe', component.options)
    }
    module.hot.accept("./OrdenesSerTecPantalla.vue?vue&type=template&id=42e37afe&", function () {
      api.rerender('42e37afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesSerTec/OrdenesSerTecPantalla.vue"
export default component.exports